export enum StudyAreaStatus {
    Outstanding = 'Outstanding',
    Paid = 'Paid',
    Test = 'Test',
}